<app-topheader></app-topheader>
<div class="scrollingcontainer meal-page-scroll">

    <div class="container">
        <app-fancy-page-title topTitle="TODAY IN THE RESTAURANT" subTitle=""></app-fancy-page-title>

        <app-longgoldbar></app-longgoldbar>


        <app-meal-selection-page></app-meal-selection-page>



    </div>
</div>
<app-bottommenu></app-bottommenu>